import { Grid, Typography } from "@mui/material";
import { ReactNode } from "react";
import { AIOption } from "../AI-Types";
import OptionItem from "./OptionItem";

type Props = {
    children: ReactNode,
    groupName: string,
    selectedOption?: AIOption | AIOption[],
    onSelect: (option: AIOption) => void,
    hideHeading?: boolean,
    options: AIOption[]
}

const OptionListAlt = ({ groupName, options, selectedOption, onSelect, children, hideHeading = false }: Props) => {
    if (options.length === 0) return null;

    const isSelected = (option: AIOption) => {
        if (!selectedOption) return false;

        if (Array.isArray(selectedOption)) {
            return selectedOption.some(s => s.name === option.name);
        }

        return selectedOption.name === option.name;
    }

    return (
        <Grid item container xs={12} spacing={4} key={groupName}>
            {!hideHeading && <Grid item xs={12}>
                <Typography variant='h6'>{groupName} {children}</Typography>
            </Grid>}

            {options.map(item => <OptionItem key={item.name} item={item} selected={isSelected(item)} onSelect={(selectedOption) => onSelect(selectedOption)} />)}
        </Grid>
    )

}

export default OptionListAlt;